import React, { useContext, useEffect, useState } from 'react'
import { EditingKnowledgeDispatch } from '../..'
import './index.css'
import {
    KnowledgeAnswerModel,
    ImageAnswerModel,
    FileAnswerModel,
} from '../../../../model/knowledge.model'
import InputItem from '../InputItem'
import AddInputButton from '../AddInputButton'
import AnswerMenu, { AnswerType } from '../AnswerMenu'
import CardAnswer from './CardAnswer'
import {
    makeTextEmptyAnswer,
    makeCardEmptyAnswer,
    makeImageEmptyAnswer,
    makeFileEmptyAnswer,
    makeMiniEmptyAnswer,
    makeVideoAnswer,
} from '../../answerHelper'
import { DeleteIcon } from '../../../../conf/images'
import ImageAnswer from './ImageAnswer'
import FileAnswer from './FileAnswer'
import MpCardAnswer from './MpCardAnswer'
import VideoAnswer from './VideoAnswer'

interface KAnswersSectionProps {
    answers?: KnowledgeAnswerModel[]
    disabled?: boolean
    addDisabled?: boolean
    change?: (any) => void
}
const DeleteButton = ({ onClick }: { onClick: () => void }) => {
    return (
        <div className='delete-button' onClick={onClick}>
            <img src={DeleteIcon} alt='x' />
        </div>
    )
}
const KAnswersSection: React.FC<KAnswersSectionProps> = (props) => {
    const { answers = [], disabled, addDisabled } = props
    const { dispatch } = useContext(EditingKnowledgeDispatch)
    const [answerMenuOpen, setAnswerMenuOpen] = useState(false)
    const handleAnswerTypeSelect = (type: AnswerType) => {
        setAnswerMenuOpen(false)
        switch (type) {
            case 'text':
                dispatch({
                    type: 'addKAnswer',
                    payload: makeTextEmptyAnswer(),
                })
                break
            case 'card':
                dispatch({
                    type: 'addKAnswer',
                    payload: makeCardEmptyAnswer(),
                })
                break
            case 'mini': {
                dispatch({
                    type: 'addKAnswer',
                    payload: makeMiniEmptyAnswer(),
                })
            }
        }
    }
    const hanleAddMediaAnswer = (
        type: AnswerType,
        src: string,
        name: string
    ) => {
        // 图片类型
        if (type === 'image') {
            const imageAnswer: ImageAnswerModel = {
                ResourceUrl: src,
                Thumb: '',
                FileName: name,
                SourceUrl: src,
            }
            let answerObj = makeImageEmptyAnswer()
            answerObj.k_answer = JSON.stringify(imageAnswer)
            dispatch({
                type: 'addKAnswer',
                payload: answerObj,
            })
        }
        // 视频类型
        if (type === 'video/mp4') {
            const imageAnswer: ImageAnswerModel = {
                ResourceUrl: src,
                Thumb: '',
                Title: name,
                Description: '',
                SourceUrl: src,
            }
            let answerObj = makeVideoAnswer()
            answerObj.k_answer = JSON.stringify(imageAnswer)
            dispatch({
                type: 'addKAnswer',
                payload: answerObj,
            })
        }
        // 文件类型
        if (type === 'file') {
            const imageAnswer: FileAnswerModel = {
                SourceUrl: src,
                FileName: name,
            }
            let answerObj = makeFileEmptyAnswer()
            answerObj.k_answer = JSON.stringify(imageAnswer)
            dispatch({
                type: 'addKAnswer',
                payload: answerObj,
            })
        }
        // 小程序
        if (type === 'mini') {
            let answerObj = makeMiniEmptyAnswer()
            dispatch({
                type: 'addKAnswer',
                payload: answerObj,
            })
        }
    }
    useEffect(() => {
        // console.log('answerMenuOpen', answerMenuOpen)
        props.change && props.change(answerMenuOpen)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [answerMenuOpen])
    // console.log('11', answers, answerMenuOpen)
    return (
        <div className='k-answer-section'>
            <div className='title'>
                <p className='h-title'>答案</p>
                <p className='desc'>机器人如何回答上述问题，多答案将依次回复</p>
            </div>
            {/* <RcUpload {...uploadProps}>开始上传</RcUpload> */}
            {answers.map((item, index) => (
                <div className='answer-item' key={item.ka_id || item.flag_id}>
                    {item.k_answer_type === 0 &&
                        (item.k_answer.indexOf('Mp_App_Id') === -1 ? (
                            !disabled ? (
                                <InputItem
                                    disabled={disabled}
                                    value={item.k_answer}
                                    placeholder='请输入答案'
                                    onChange={(value) =>
                                        dispatch({
                                            type: 'updateKAnswer',
                                            payload: {
                                                value,
                                                index,
                                            },
                                        })
                                    }
                                    // deleteable={answers.length > 1}
                                    onDelete={() =>
                                        dispatch({
                                            type: 'deleteKAnswer',
                                            payload: index,
                                        })
                                    }
                                />
                            ) : (
                                <p key={index} className='disable-answer-item'>
                                    {item.k_answer}
                                </p>
                            )
                        ) : (
                            <MpCardAnswer
                                answer={item.k_answer}
                                finished={item.finished}
                                isLocked={disabled}
                                onEdit={() => {
                                    if (disabled) {
                                        return
                                    }
                                    dispatch({
                                        type: 'updateKAnswer',
                                        payload: {
                                            value: item.k_answer,
                                            index,
                                            finished: false,
                                        },
                                    })
                                }}
                                onCancel={() => {
                                    if (item.ka_id) {
                                        dispatch({
                                            type: 'updateKAnswer',
                                            payload: {
                                                value: item.k_answer,
                                                index,
                                                finished: true,
                                            },
                                        })
                                    } else {
                                        dispatch({
                                            type: 'deleteKAnswer',
                                            payload: index,
                                        })
                                    }
                                }}
                                onConfirm={(answer: string) => {
                                    dispatch({
                                        type: 'updateKAnswer',
                                        payload: {
                                            value: answer,
                                            index,
                                            finished: true,
                                        },
                                    })
                                }}
                            />
                        ))}
                    {item.k_answer_type === 5 && (
                        <CardAnswer
                            answer={item.k_answer}
                            finished={item.finished}
                            onEdit={() => {
                                if (disabled) {
                                    return
                                }
                                dispatch({
                                    type: 'updateKAnswer',
                                    payload: {
                                        value: item.k_answer,
                                        index,
                                        finished: false,
                                    },
                                })
                            }}
                            onCancel={() => {
                                if (item.ka_id) {
                                    dispatch({
                                        type: 'updateKAnswer',
                                        payload: {
                                            value: item.k_answer,
                                            index,
                                            finished: true,
                                        },
                                    })
                                } else {
                                    dispatch({
                                        type: 'deleteKAnswer',
                                        payload: index,
                                    })
                                }
                            }}
                            onConfirm={(answer: string) => {
                                dispatch({
                                    type: 'updateKAnswer',
                                    payload: {
                                        value: answer,
                                        index,
                                        finished: true,
                                    },
                                })
                            }}
                        />
                    )}
                    {item.k_answer_type === 1 && (
                        <ImageAnswer
                            answer={item.k_answer}
                            isLocked={disabled}
                            onReupload={(answer: string) => {
                                dispatch({
                                    type: 'updateKAnswer',
                                    payload: {
                                        value: answer,
                                        index,
                                    },
                                })
                            }}
                        />
                    )}

                    {item.k_answer_type === 4 && (
                        <FileAnswer
                            answer={item.k_answer}
                            isLocked={disabled}
                            onReupload={(answer: string) => {
                                dispatch({
                                    type: 'updateKAnswer',
                                    payload: {
                                        value: answer,
                                        index,
                                    },
                                })
                            }}
                        />
                    )}
                    {item.k_answer_type === 6 && (
                        <VideoAnswer
                            answer={item.k_answer}
                            isLocked={disabled}
                            onReupload={(answer: string) => {
                                dispatch({
                                    type: 'updateKAnswer',
                                    payload: {
                                        value: answer,
                                        index,
                                    },
                                })
                            }}
                        />
                    )}

                    {!disabled && answers.length > 0 && (
                        <DeleteButton
                            onClick={() =>
                                dispatch({
                                    type: 'deleteKAnswer',
                                    payload: index,
                                })
                            }
                        />
                    )}
                    {/* {!disabled &&
						answers.length > 0 &&
						item.k_answer_type === 5 &&
						!!(item.finished || item.ka_id) && (
							<DeleteButton
								onClick={() =>
									dispatch({
										type: "deleteKAnswer",
										payload: index,
									})
								}
							/>
						)} */}
                </div>
            ))}

            {!disabled && (
                <AnswerMenu
                    isOpen={answerMenuOpen}
                    onClose={() => setAnswerMenuOpen(false)}
                    onSelect={handleAnswerTypeSelect}
                    onUploaded={hanleAddMediaAnswer}
                />
            )}
            {!disabled && (
                <AddInputButton
                    disabled={addDisabled}
                    onClick={() => setAnswerMenuOpen(true)}
                />
            )}
        </div>
    )
}

export default KAnswersSection
